import React from 'react';

import MaskedInput, { MaskedInputProps } from './MaskedInput';

export interface MaskedInputZipcodeProps extends Omit<MaskedInputProps, 'mask'> {}

const MaskedInputZipcode: React.FC<MaskedInputZipcodeProps> = (props) => (
  <MaskedInput mask={[/\d/, /\d/, /\d/, /\d/, /\d/]} placeholder="00000" inputMode="numeric" {...props} />
);

export default MaskedInputZipcode;
